export const owner = {
    message: "Are you confident in the responses? Once approved, you won't be able to make any changes.",
    note: "Note: You can modify the responses as many times as needed until approval."
}

export const supervisor = {
    message: 'Are you confident in the responses? Once approved, they will be published and visible to the public.',
    note: 'Note: You can modify the responses as many times as needed.'
}

export const deleteItem = {
    message: 'Are you sure you want to delete this item?',
    note: 'Note: This action cannot be undone.'
}